import { DollarSign, Stethoscope, Users } from "lucide-react";
import { AC } from "@/constants/testIds";
import { ACCESS_AREAS, ACCESS_LEVELS, cellLevel } from "@/lib/subtabAccess";

const AREA_THEME = {
  front_desk: {
    icon: Users,
    header: "ac-matrix-head--front-desk",
  },
  clinical: {
    icon: Stethoscope,
    header: "ac-matrix-head--clinical",
  },
  billing: {
    icon: DollarSign,
    header: "ac-matrix-head--billing",
  },
};

export default function SubtabAccessMatrix({ matrix, onChange, disabled }) {
  return (
    <div className="ac-matrix-stack" data-testid={AC.matrix}>
      {ACCESS_AREAS.map((area) => {
        const theme = AREA_THEME[area.id];
        const Icon = theme.icon;
        return (
          <section key={area.id} className="ac-matrix">
            <header className={`ac-matrix-head ${theme.header}`}>
              <Icon className="h-4 w-4" aria-hidden="true" />
              <h3>{area.label}</h3>
            </header>
            <table className="ac-matrix-table">
              <thead>
                <tr>
                  <th scope="col">Subtab</th>
                  {ACCESS_LEVELS.map((level) => (
                    <th key={level.id} scope="col">
                      {level.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {area.tabs.map((tab) => {
                  const selected = cellLevel(matrix, area.id, tab.id);
                  return (
                    <tr key={tab.id}>
                      <th scope="row">{tab.label}</th>
                      {ACCESS_LEVELS.map((level) => {
                        const inputId = `ac-${area.id}-${tab.id}-${level.id}`;
                        return (
                          <td key={level.id}>
                            <label className="ac-radio" htmlFor={inputId}>
                              <input
                                id={inputId}
                                type="radio"
                                name={`ac-${area.id}-${tab.id}`}
                                value={level.id}
                                checked={selected === level.id}
                                disabled={disabled}
                                data-testid={`ac-radio-${area.id}-${tab.id}-${level.id}`}
                                onChange={() => onChange(area.id, tab.id, level.id)}
                              />
                              <span className="sr-only">
                                {tab.label} {level.label}
                              </span>
                            </label>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        );
      })}
    </div>
  );
}
